export default __webpack_public_path__ + "static/media/480_dummy2016-coach02-mobile-de.03efa3d1.png";